import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CustomLineChart from "../../../../Common/Components/Charts/LineChart";
import CircularProgress from "../../../../Common/Components/CircularLoader";
import axiosMain from "../../../../http/axiosMain";

const reachLineChartData = [
  { name: "Reels", key: "reels", fill: "#68E484" },
  { name: "Stories", key: "stories", fill: "#68C8E4" },
  { name: "Posts", key: "posts", fill: "#E45787" },
];

const TotalReach = () => {
  const [totalReachLoading, setTotalReachLoading] = useState(true);
  const [totalReachInsights, setTotalReachInsights] = useState([]);

  const getInstagramTotalReach = async () => {
    try {
      setTotalReachLoading(true);
      const resp = await axiosMain.get("api/v1/insights/instagram-total-reach");
      if (resp.status === 200 && resp.data?.success) {
        setTotalReachInsights(resp.data?.data || []);
      } else {
        toast.error(resp.data?.message || "Something went wrong", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || err?.message || "Something went wrong",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    } finally {
      setTotalReachLoading(false);
    }
  };

  useEffect(() => {
    getInstagramTotalReach();
  }, []);

  return (
    <div className="instagram-container">
      <div className="options-content">
        <span className="platformtitle card-title">Total Reach</span>
      </div>
      <div
        className="mt-4 flex"
        style={{
          marginTop: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {!totalReachLoading && totalReachInsights?.length ? (
          <CustomLineChart
            data={totalReachInsights || []}
            lines={reachLineChartData}
            width={1000}
            height={332}
          />
        ) : totalReachLoading ? (
          <CircularProgress containerStyle={{ minWidth: "332px" }} />
        ) : (
          <div className="no-data">
            <small>No Data Found.</small>
          </div>
        )}
      </div>
    </div>
  );
};

export default TotalReach;
